<template>
  <div class="CustomerList">
    <!-- <div
      class="item acea-row row-between-wrapper"
      v-for="item in list"
      :key="item.id"
      @click="
        $router.push(
          '/customer/chat/' +
            item.uid +
            '/' +
            productId +
            (orderId ? '?orderId=' + orderId : '')
        )
      "
    > -->
      <div class="pictrue"><img :src="indexList.service_code" /></div>
      <div class="text line1">迷迭商城客服24小时为您服务！</div>
    </div>
  </div>
</template>
<script>
import { serviceList ,getRechargeApi} from "@api/user";
export default {
  name: "CustomerList",
  data() {
    return {
      list: [],
      productId: 0,
      orderId: "",
      indexList:[],
    };
  },
  watch: {
    $route(n) {
      if (n.name === "CustomerList") {
        if (n.params.productId) this.productId = n.params.productId;
        else this.productId = 0;

        if (n.query.orderId) this.orderId = n.query.orderId;
        else this.orderId = "";
      }
    }
  },
  methods: {
    getIndex(){
      getRechargeApi().then(res=>{
      this.indexList = res.data
       console.log(res.data)
      })
    },
    getList() {
      serviceList().then(res => {
        this.list = res.data;
      });
    }
  },
  mounted() {
    this.getList();
    this.getIndex();
    if (this.$route.params.productId)
      this.productId = this.$route.params.productId;
    if (this.$route.query.orderId) this.orderId = this.$route.query.orderId;
  }
};
</script>
<style scoped>
.CustomerList {
  width: 100%;
  margin-top: 0.13rem;
}
.CustomerList img{
  width: 100%;
}
.CustomerList .line1{
  text-align: center;
}
.CustomerList .item {
  height: 1.38rem;
  border-bottom: 1px solid #eee;
  padding: 0 0.24rem;
  background-color: #fff;
}
.CustomerList .item .pictrue {
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 50%;
  border: 0.03rem solid #fff;
  box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -webkit-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -moz-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
}
.CustomerList .item .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.CustomerList .item .text {
  width: 5.82rem;
  font-size: 0.32rem;
  color: #000;
  text-align: center;
}
</style>

